import { TIME_REPORT_SCOPE } from "@msys/textutils";
import { AvailableReplacementsModal } from "../documents/AvailableReplacementsModal.js";

interface Props {
  handleClose(): void;
}

export function TimeReportTextsAvailableReplacementsModal({
  handleClose,
}: Props) {
  return (
    <AvailableReplacementsModal
      scope={TIME_REPORT_SCOPE}
      handleClose={handleClose}
    />
  );
}
